<template>
  <div class="topicsview fixspace">
    <section class="hero is-medium has-background-light has-text-centered topics">
      <div class="hero-body">
        <div class="container">
          <div class="mb-5" v-if="!isFirstPageFinished">
            <figure class="image skeleton topicsimg">
              <div class="skeleton-block"></div>
            </figure>
          </div>
          <div v-if="isFirstPageFinished">
            <div
              v-if="this.scenario"
              class="mb-5 shadowed topicsimg has-background-grey"
              :style="
                'background-image: url('+ this.scenario.description.image +');'
              ">
            </div>
          </div>
          <div class="pt-2 pb-6 mb-2" v-if="!isFirstPageFinished">
            <b-skeleton width="30%" size="is-large" position="is-centered"></b-skeleton>
          </div>
          <h1 class="is-size-4 has-text-weight-semibold pt-2 pb-6"
            v-if="this.scenario && isFirstPageFinished">
            {{ this.scenario.name}}
          </h1>
          <b-button
            class="my-5 mx-1 has-text-weight-semibold stick-button"
            :label="$t('general.share')"
            type="is-black"
            @click="shareModal" />
          <b-button
            class="my-5 mx-1 has-text-weight-semibold stick-button"
            :label="$t('general.submit')"
            type="is-black"
            tag="router-link"
            to="/submit"
            outlined />
          <div>
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
      </div>
    </section>

    <section class="section" style="background:#fff;">
      <div class="container">
        <div class="columns">
          <div class="column is-three-fifths is-offset-one-fifth">

            <div class="columns is-variable is-5 is-multiline" v-if="!isFirstPageFinished">
              <div class="column is-half" v-for="i in ske" :key="i">
                <div class="media-content">
                  <figure class="image is-16by9 skeleton">
                    <div class="skeleton-block"></div>
                  </figure>
                  <div class="pt-1"><b-skeleton></b-skeleton></div>
                  <b-skeleton width="30%"></b-skeleton>
                </div>
              </div>
            </div>

            <div class="columns is-variable is-5 is-multiline" v-if="isFirstPageFinished">
              <div class="column is-half" v-for="item in list" :key="item.id">
                <router-link :to='"/video/" + item.id' :title="item.title">
                  <video-item
                    :channel-title="item.channel.title"
                    :youtube-id="item.provider_video_id"
                    :title="item.title" >
                  </video-item>
                </router-link>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="container has-text-centered" v-if="isEmpty">
        <h2 class="is-size-5-desktop is-size-6-mobile has-text-weight-semibold pb-5">
          {{ $t('general.stilllooking') }}
        </h2>
        <button class="button mx-1 px-5 my-5 is-black">
          <span class="has-text-weight-semibold">
            {{ $t('general.submitwork') }}
          </span>
        </button>
        <div class="py-6">
          <img src="/assets/empty.png" :alt="$t('general.stilllooking')">
        </div>
      </div>

      <div class="container has-text-centered">
        <infinite-loading
          v-if="isFirstPageFinished"
          spinner="waveDots"
          @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </section>
  </div>
</template>

<script>
import ShareModal from 'components/ShareModal.vue';
import { getVideos, getScenarioById } from '@/api/api';

export default {
  name: 'TagPage',

  metaInfo() {
    return {
      title: `${this.title} - ${this.$t('title.topics')}`,
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: `${this.title} - ${this.$t('title.topics')}` },
        { property: 'og:image', vmid: 'og:image', content: this.scenario ? this.scenario.description.image : '' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      scenario: null,
      currentUrl: '',
      list: [],
      limit: 12,
      page: 1,
      total: 1,
      isEmpty: false,
      isFirstPageFinished: false,
      ske: 12,
    };
  },
  computed: {
  },

  created() {
    this.currentUrl = window.location.href;
    this.fetchData(this.$route.params.id);
  },

  methods: {
    shareModal() {
      this.$FModal.show({
        component: ShareModal,
        overlayStyles: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
      },
      {
        shareId: this.id,
        shareRoute: 'topics',
        shareTitle: this.title,
      });
    },

    fetchData(scenarioId) {
      getScenarioById(scenarioId, { headers: { locale: this.$i18n.locale } })
        .then((scenario) => {
          const infoData = scenario.data.data;
          this.id = infoData.id;
          this.title = infoData.name;
          this.scenario = scenario.data.data;

          this.$emit('forGtagStatus', `${this.title} - ${this.$t('title.topics')}`);

          const params = { tags: this.scenario.tags_string, limit: this.limit, page: this.page };

          getVideos({ params })
            .then((result) => {
              const { data, total } = result.data;
              this.total = total;
              this.list = data;

              if (data.length === 0) {
                this.isEmpty = true;
              } else {
                this.page += 1;
              }

              this.isFirstPageFinished = true;
            }).catch((err) => { console.error(err); });
        }).catch((err) => {
          console.error(err);

          if (err.request.status === 404) {
            this.$router.push({ name: '404' });
          }
        });
    },

    infiniteHandler($state) {
      getVideos({ params: { tags: this.scenario.tags_string, limit: this.limit, page: this.page } })
        .then((result) => {
          const { data } = result.data;

          if (data.length > 0) {
            this.page += 1;
            this.list.push(...data);
            $state.loaded();
          } else {
            $state.complete();
          }
        }).catch((err) => { console.error(err); });
    },
  },
};
</script>

<style scoped>
section.topics {
  background: linear-gradient(
      rgba(0, 0, 0, 0.0),
      rgba(0, 0, 0, 0.0)
    ), url('/assets/topics/topics_bg.png') no-repeat center;
  background-position-y: 50%;
  /* background-size: 1920px 1080px !important; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.topicsimg {
  margin: 0 auto;
  width: 200px;
  height: 200px;
  background-size: cover;
}
</style>
